import { ProductKey } from "src/config/config";

export const getProductFromSessionStorage = (): ProductKey => {
  return (window.sessionStorage.getItem("product") as ProductKey) ?? null;
};
export const setProductToSessionStorage = (productName: string) => {
  return window.sessionStorage.setItem("product", productName);
};
export const removeProductFromSessionStorage = () => {
  return window.sessionStorage.removeItem("product");
};
export const getUserInfoFromLocalStorage = (): string | null => {
  // null과 undefined인 경우에 빈 문자열 반환
  return window.localStorage.getItem("cloudUserInfo") ?? null;
};

export const setUserInfoToLocalStorage = (userinfo: string) => {
  return window.localStorage.setItem("cloudUserInfo", userinfo);
};

export const removeUserInfoFromLocalStorage = () => {
  return window.localStorage.removeItem("cloudUserInfo");
};
